import { canUseDOM } from '@ps/web-core-utils';

export const inIframe = () => (canUseDOM ? window.self !== window.top : false);
